import React, { useState } from 'react';

import { ScreenHead } from '../../ui/screen-parts.js';
import { Chip, Panel, Segments, Empty, useFlash } from '../../ui/kit.js';
import { day } from '../../state/building.js';

import Wine from '../../media/images/modules/event-wine.jpg';
import Yoga from '../../media/images/modules/event-yoga.jpg';
import MovieNight from '../../media/images/pool-screen/poolside-movie-night.jpg';
import TownHall from '../../media/images/modules/event-townhall.jpg';
import Coffee from '../../media/images/modules/event-coffee.jpg';
import StoneCrab from '../../media/images/modules/event-stone-crab.jpg';

const SEED = [
    { id: 1, title: 'Napa wine tasting', date: day(2), time: '7:00 PM', place: 'Bayview lounge', spots: 6, going: false, note: 'Six pours with a sommelier from Wynwood Cellars.', image: Wine },
    { id: 2, title: 'Sunset yoga', date: day(3), time: '6:30 PM', place: 'Oceanfront pool deck', spots: 12, going: true, note: 'All levels. Mats and towels provided.', image: Yoga },
    { id: 3, title: 'Kids movie night', date: day(5), time: '6:00 PM', place: 'Screening room', spots: 9, going: false, note: 'Popcorn, juice boxes and a family favorite.', image: MovieNight },
    { id: 4, title: 'HOA town hall', date: day(8), time: '7:00 PM', place: 'Club room, level 2', spots: 40, going: false, note: 'Budget review and the seawall project update.', image: TownHall },
    { id: 5, title: 'Cuban coffee and pastelitos', date: day(9), time: '9:00 AM', place: 'Lobby cafe', spots: 20, going: false, note: 'Meet your neighbors over a cafecito.', image: Coffee },
    { id: 6, title: 'Stone crab season kickoff', date: day(14), time: '7:30 PM', place: 'Rooftop terrace', spots: 2, going: false, note: 'Chef station and live Latin jazz.', image: StoneCrab }
];

/* Events / Activities: what is on in the building, with RSVP. */
function EventsScreen() {
    const [flash, notify] = useFlash();
    const [events, setEvents] = useState(SEED);
    const [filter, setFilter] = useState('All');

    const rsvp = event => {
        if (!event.going && event.spots === 0) return notify(`${event.title} is full. We will let you know if a spot opens.`);

        setEvents(list => list.map(e => (e.id === event.id
            ? { ...e, going: !e.going, spots: e.spots + (e.going ? 1 : -1) }
            : e)));
        notify(event.going ? `You are off the list for ${event.title}.` : `You are going to ${event.title} on ${event.date}.`);
    };

    const shown = filter === 'Going' ? events.filter(e => e.going) : events;

    return (
        <div className="screen-content">
            <ScreenHead
                eyebrow="Events"
                title="Upcoming events"
                aside={<Segments label="Show" options={['All', 'Going']} value={filter} onChange={setFilter} />}
            />
            {flash}

            {shown.length === 0 ? <Empty>You have not RSVPed to anything yet.</Empty> : (
                <div className="cards">
                    {shown.map((e, i) => (
                        <Panel key={e.id} index={i} className={e.going ? 'panel--accent' : ''}>
                            <img className="panel__media" src={e.image} alt={e.title} loading="lazy" />
                            <div className="row__end" style={{ justifyContent: 'space-between' }}>
                                <Chip tone="muted">{e.date} · {e.time}</Chip>
                                {e.going ? <Chip tone="ok">Going</Chip> : <Chip tone={e.spots === 0 ? 'alert' : e.spots <= 3 ? 'warn' : 'info'}>
                                    {e.spots === 0 ? 'Full' : `${e.spots} spots left`}
                                </Chip>}
                            </div>
                            <h4>{e.title}</h4>
                            <p className="row__meta">{e.place} · {e.note}</p>
                            <button type="button" className={`btn btn-sm ${e.going ? 'btn-outline-light' : 'btn-primary'}`} onClick={() => rsvp(e)}>
                                {e.going ? 'Cancel RSVP' : 'RSVP'}
                            </button>
                        </Panel>
                    ))}
                </div>
            )}
        </div>
    );
}

export default EventsScreen;
